export const MAX_TAG_KEYS = 10;
export const MAX_TAG_VALUES = 20;

export type PolicyTags = Record<string, string[]>;

export function addScopeValue(
  tags: PolicyTags,
  key: string,
  value: string,
): { tags: PolicyTags; limitReached: boolean } {
  const current = tags[key] ?? [];
  if (current.includes(value)) return { tags, limitReached: false };
  if (
    current.length >= MAX_TAG_VALUES ||
    (!tags[key] && Object.keys(tags).length >= MAX_TAG_KEYS)
  ) {
    return { tags, limitReached: true };
  }
  return {
    tags: { ...tags, [key]: [...current, value] },
    limitReached: false,
  };
}

/** Removes one value; a key with no value left imposes no restriction. */
export function removeTag(
  tags: PolicyTags,
  key: string,
  value: string,
): PolicyTags {
  const values = (tags[key] ?? []).filter((item) => item !== value);
  const { [key]: _removed, ...rest } = tags;
  return values.length > 0 ? { ...rest, [key]: values } : rest;
}
